module.exports = __webpack_public_path__ + "img/video5.4d90c809.jpg";